import React, { FC } from 'react';
import cls from './FormBlock.module.css';
import classNames from 'classnames';

export const FormBlock = ({ children }) => {
    return <div className={classNames(cls.paymentFormBlock)}>{children}</div>;
};
